import React from 'react'; 

interface CreditShowProps {
  credit: string;
  fontSize?: number;
}

// 定义信用等级颜色配置
const creditColors: Record<string, { text: string }> = {
  '一般': {
    text: '#999999'    // 灰色文字
  },
  '较好': {
    text: '#1976D2'    // 蓝色文字
  },
  '优秀': {
    text: '#FFA000'    // 金色文字
  },
  '极好': {
    text: '#7B1FA2'    // 深紫色文字
  }
};

// 默认样式
const defaultStyle = {
  text: '#999999'    // 默认灰色文字
};

const CreditShow: React.FC<CreditShowProps> = ({ credit, fontSize = 12 }) => {
  // 获取对应的颜色配置，如果没有匹配的配置则使用默认样式
  const colors = creditColors[credit] || defaultStyle;

  return (
    <div style={styles.container}>
      <span style={{ fontSize: '12px', color: '#666' }}>信用：</span>
      <span style={{...styles.text, color: colors.text, fontSize }}>
        {credit}
      </span>
    </div>
  );
};

const styles = {
  container: {
    alignSelf: 'center',
  },
  text: {
    fontWeight: '500',
  },
};

export default CreditShow; 